import { render, staticRenderFns } from "./TablePublicCom.vue?vue&type=template&id=70503544&scoped=true"
import script from "./TablePublicCom.vue?vue&type=script&lang=js"
export * from "./TablePublicCom.vue?vue&type=script&lang=js"
import style0 from "./TablePublicCom.vue?vue&type=style&index=0&id=70503544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70503544",
  null
  
)

export default component.exports